import React from 'react';

const Header = () => (
  <header>
    <h1>Data Structures & Algorithms (DSA)</h1>
    <nav>
      <a href="#intro">Introduction</a>
      <a href="#array">Arrays</a>
      <a href="#linkedlist">Linked Lists</a>
      <a href="#stackqueue">Stacks & Queues</a>
      <a href="#trees">Trees & Graphs</a>
      <a href="#sorting">Sorting Algorithms</a>
      <a href="#searching">Searching Algorithms</a>
      <a href="#dp">Dynamic Programming</a>
    </nav>
  </header>
);

export default Header;
